var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerachDiveCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.215 1.269C10.499 1.269 1 10.776 1 22.503c0 11.727 9.498 21.234 21.214 21.234s21.214-9.507 21.214-21.234c0-11.727-9.498-21.234-21.214-21.234z",
    stroke: "#ECECEC",
    strokeWidth: 1.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.625 21.625c-2.412 0-4.375 1.987-4.375 4.43 0 3.372 3.787 6.65 3.948 6.788a.657.657 0 0 0 .854 0c.161-.139 3.948-3.417 3.948-6.788 0-2.443-1.963-4.43-4.375-4.43zm0 6.125c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.785 1.75 1.75-.785 1.75-1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.125 19h-.052l-.63-4.725a2.63 2.63 0 0 0-2.6-2.275H16.157a2.63 2.63 0 0 0-2.598 2.275L12.928 19h-.053a.878.878 0 0 0-.875.875c0 .481.394.875.875.875h.875v7.875a2.633 2.633 0 0 0 2.625 2.625h8.059a12.69 12.69 0 0 1-1.05-1.75h-7.009a.878.878 0 0 1-.875-.875V20.75h10.001a5.975 5.975 0 0 1 3.124-.875c1.137 0 2.205.315 3.124.875h.376a.878.878 0 0 0 .875-.875.878.878 0 0 0-.875-.875zm-15.26 0h-2.17l.595-4.489a.876.876 0 0 1 .866-.761h1.409l-.7 5.25zm4.76 0h-2.992l.7-5.25h2.292V19zm1.75 0v-5.25h2.293l.7 5.25h-2.993zm4.76 0-.7-5.25h1.409c.437 0 .805.324.866.761L30.305 19h-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.781 27.75h1.313c.844 0 1.531-.687 1.531-1.531v-1.313c0-.844-.687-1.531-1.531-1.531H18.78c-.844 0-1.531.687-1.531 1.531v1.313c0 .844.687 1.531 1.531 1.531z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerachDiveCenter);
export default __webpack_public_path__ + "static/media/serach-dive-center.817c52386109cd8a2844c042e4b2d8b9.svg";
export { ForwardRef as ReactComponent };